import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { getDomainAvailability, setDomainName } from "../services/apiService";
import { toast } from "react-toastify";
import { parseJSON } from "date-fns";
import WebsiteSetupMessage from "./WebsiteSetupMessage"
import { fetchBusinessList } from "../services/apiService";

export default function DomainSearch({ onSelect }) {

  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState("");
  const [websiteName, setWebsiteName] = useState("");

  const checkDomainAvailability = async (domain) => {
    try {
      const result = await getDomainAvailability("api/v1/domain/check", domain);
      if (result.success) {
        let searchResult = [];
        searchResult.push(JSON.parse(result.data));
        setResults(searchResult);
        setLoading(false);
      } else if (!result.success) {
        toast.error(result.message);
        setLoading(false);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
      setLoading(false);
    }
  };

  const searchDomains = async () => {
    isValidDomain(searchTerm.trim());
    if (!searchTerm.trim()) return;
    setLoading(true);
    checkDomainAvailability(searchTerm);
  };

  const handleSelect = async (domain) => {

    try {
      const result = await setDomainName(
        "api/v1/domain/domainSelection",
        domain
      );
      if (result.success) {
        toast.success(result.message);
        setSelectedDomain(domain);
        if (onSelect) onSelect(domain);
      } else if (!result.success) {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
      setLoading(false);
    }
  };

  const isValidDomain = (domain) => {
    domain = domain.trim().toLowerCase();

    if (domain == "") {
      toast.error("Please enter your domain name !");
      return false;
    }

    const domainRegex =
      /^(?!-)([a-z0-9-]{1,63})(?<!-)\.([a-z]{2,})(\.[a-z]{2,})*$/;

    if (!domainRegex.test(domain)) {
      toast.error("Please enter valid domain name !");
      return false;
    }
  };


  const loadData = async () => {
    try {
      const result = await fetchBusinessList("api/v1/list");
      if (result.success && result?.data.length == 1) {
          setWebsiteName(
            result.data[0].websiteName
              .trim()
              .replace(/[-\s]+/g, "-")
              .replace(/^-/, "")
              .replace(/[^a-zA-Z0-9àç_èéù-]+/g, "")
              .toLowerCase()
          );
          setSelectedDomain(result.data[0].domainName);
      } else if (!result.success) {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("Failed to load data", error);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="container">
      <Header />
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div
              style={{
                width: "100%",
                maxWidth: "600px",
                margin: "20px",
                padding: "20px",
                borderRadius: "10px",
                background: "#fff",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <h3 style={{ marginBottom: "15px" }}>Search Your Domain</h3>

              {/* Search Box */}
              <div style={{ display: "flex", gap: "10px" }}>
                <input
                  style={{
                    flex: 1,
                    padding: "10px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    fontSize: "16px",
                  }}
                  type="text"
                  placeholder="Type the domain you want"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                />

                <button
                  style={{
                    padding: "10px 20px",
                    borderRadius: "8px",
                    background: "#2563eb",
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={searchDomains}
                  disabled={loading}
                >
                  {loading ? "Searching..." : "Search"}
                </button>
              </div>
              <div style={{ fontSize: "small" }}>
                For Example - {websiteName}.com, {websiteName}.org,{" "}
                {websiteName}.co.in, {websiteName}..net | try any other TLD
              </div>

              {/* Results */}
              <div style={{ marginTop: "20px" }}>
                {results.length > 0 && (
                  <div>
                    <h5>Your Domain Available Result</h5>
                    <ul style={{ listStyle: "none", padding: 0 }}>
                      {results.map((item) => (
                        <li
                          key={item.domain}
                          onClick={() =>
                            item.available && handleSelect(item.domain)
                          }
                          style={{
                            padding: "12px",
                            marginBottom: "10px",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                            cursor: item.available ? "pointer" : "not-allowed",
                            background:
                              selectedDomain === item.domain
                                ? "#dbeafe"
                                : item.available
                                ? "#f9f9f9"
                                : "#ffe4e6",
                            opacity: item.available ? 1 : 0.6,
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>{item.domain}</span>
                          <span
                            style={{
                              fontWeight: "bold",
                              color: item.available ? "black" : "red",
                            }}
                          >
                            {item.available ? "Available" : "Taken"}
                          </span>
                          <span
                            style={{
                              fontWeight: "bold",
                              color: item.available ? "green" : "red",
                            }}
                          >
                            {item.available ? "Make It Yours" : "Taken"}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            {selectedDomain && (
              <div>
                <p style={{ marginTop: "15px", fontSize: "16px" }}>
                  Selected Domain: <strong>{selectedDomain}</strong>
                </p>

                <WebsiteSetupMessage domainName={selectedDomain} />
              </div>
            )}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
